var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "v-cards"
  }, [_vm._l(_vm.items, function (value) {
    return [_c('form-applications-item', _vm._g(_vm._b({
      key: value === null || value === void 0 ? void 0 : value.id
    }, 'form-applications-item', {
      value,
      list: _vm.list,
      recruitment: value.recruitment,
      applications: _vm.applications
    }, false), {
      push: _vm.push,
      pull: _vm.pull
    }))];
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }